<template>
  <layout-header></layout-header>
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 mx-auto">
            <div class="breadcrumb">
              <nav aria-label="breadcrumb" class="page-breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/home/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item" aria-current="page">Orders</li>
                  <li class="breadcrumb-item" aria-current="page">ID 2378910</li>
                </ol>
              </nav>
            </div>
            <div class="row booking-details">
              <div class="col-md-4">
                <div>
                  <h4 class="mb-2">Booking ID: 2378910</h4>
                  <p class="fs-12">
                    <i class="feather-calendar me-1"></i> 22 Sep 2023 10:23 AM
                  </p>
                </div>
              </div>
              <div class="col-md-8">
                <div class="d-flex gap-3 justify-content-end">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light d-flex align-items-center justify-content-center"
                    ><i class="ti ti-current-location me-1"></i>LiveTrack</a
                  >
                  <router-link
                    to="/invoice"
                    class="btn btn-light d-flex align-items-center justify-content-center"
                    ><i class="ti ti-file-text me-1"></i>Invoice</router-link
                  >
                  <a
                    href="javascript:void(0);"
                    class="btn btn-light d-flex align-items-center justify-content-center"
                    ><i class="ti ti-printer me-1"></i>Print</a
                  >
                </div>
              </div>
            </div>
            <!-- Slot Booked -->
            <div class="slot-box mt-3">
              <div class="row">
                <div class="col-md-3">
                  <div class="slot-booked">
                    <h6>Booked Slot</h6>
                    <ul>
                      <li class="fs-12 d-flex align-items-center mb-2">
                        <i class="feather-calendar me-1"></i> 22 Sep 2023
                      </li>
                      <li class="fs-12 d-flex align-items-center">
                        <i class="feather-clock me-1"></i> 10:00AM - 11:00AM
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="slot-user">
                    <h6>Services Provider</h6>
                    <div class="slot-chat">
                      <div class="slot-user-img d-flex align-items-center">
                        <img
                          class="avatar rounded-circle me-2"
                          src="@/assets/img/profiles/avatar-31.jpg"
                          alt="image"
                        />
                        <div class="slot-user-info">
                          <p class="mb-1 fs-12">John Doe</p>
                          <p class="mb-0 fs-12">john@example.com</p>
                        </div>
                      </div>
                      <div class="chat-item d-flex align-items-center">
                        <div class="slot-user-info">
                          <p class="mb-0 fs-12">+1 888 888 8888</p>
                          <p class="mb-0 fs-12">Montana, USA</p>
                        </div>
                        <div>
                          <router-link
                            to="/customer/user-chat"
                            class="btn btn-sm btn-dark d-flex align-items-center"
                          >
                            <i class="ti ti-message me-1"></i> Chat</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="slot-action">
                    <h6>Booking Status</h6>
                    <span class="badge badge-success-100 p-2 me-3">Completed</span>
                    <span class="badge badge-skyblue p-2">Pending</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Slot Booked -->

            <div class="payment-summary">
              <div class="row">
                <!-- Service Location -->
                <div class="col-md-6 service-location">
                  <h6 class="order-title">Service Location & Contact Details</h6>
                  <div class="slot-address">
                    <ul>
                      <li>
                        <span><i class="ti ti-map-pin"></i></span>
                        <div>
                          <h6>Address</h6>
                          <p>38 Taylor Street Mount Vernon, NY 10550</p>
                        </div>
                      </li>
                      <li>
                        <span><i class="ti ti-mail"></i></span>
                        <div>
                          <h6>Email</h6>
                          <p>johnsmith@example.com</p>
                        </div>
                      </li>
                      <li>
                        <span><i class="ti ti-phone"></i></span>
                        <div>
                          <h6>Phone</h6>
                          <p>+1 888 888 8888</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="slot-pay">
                    <p>Payment</p>
                    <span class="fs-14"
                      >Visa **** **** **** **56
                      <img src="@/assets/img/icons/visa.svg" alt="Img"
                    /></span>
                  </div>
                </div>
                <!-- /Service Location -->

                <!-- Order Summary -->
                <div class="col-md-6 order-summary">
                  <h6 class="order-title">Order Summary</h6>
                  <div class="ord-summary">
                    <div class="order-amt">
                      <div class="order-info">
                        <div class="order-img">
                          <img src="@/assets/img/providers/provider-26.jpg" alt="img" />
                        </div>
                        <div class="order-profile">
                          <h6>Computer Services</h6>
                          <p>Newyork, USA</p>
                        </div>
                      </div>
                      <h5>$599.00</h5>
                    </div>
                    <ul>
                      <li>Sub Total <span class="ord-amt">$257.00</span></li>
                      <li>
                        <p class="ord-code mb-0">
                          Discount
                          <span class="ms-2 p-2 badge badge-info-transparent"
                            >NEW 2024</span
                          >
                        </p>
                        <span class="ord-amt">-$11.00</span>
                      </li>
                      <li>Tax @ 12.5% <span class="ord-amt">$5.36</span></li>
                      <li class="ord-total mb-0">
                        Total <span class="ord-amt">$251.36</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- /Order Summary -->

                <div class="row booking">
                  <!-- Booking History -->
                  <div class="col-md-6">
                    <h6 class="order-title">Booking History</h6>
                    <div class="book-history">
                      <ul>
                        <li>
                          <h6>Booking</h6>
                          <p><i class="ti ti-calendar me-1"></i> September 5, 2023</p>
                        </li>
                        <li>
                          <h6>Provider Accept</h6>
                          <p><i class="ti ti-calendar me-1"></i> September 5, 2023</p>
                        </li>
                        <li>
                          <h6>Completed on</h6>
                          <p><i class="ti ti-calendar me-1"></i> September 5, 2023</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- /Booking History -->

                  <!-- Reviews -->
                  <div class="col-md-6">
                    <div class="order-reviews">
                      <div class="row align-items-center mb-4">
                        <div class="col-5">
                          <h6 class="order-title">Reviews</h6>
                        </div>
                        <div class="col-7 text-end d-flex justify-content-end">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-sm d-flex align-items-center btn-dark"
                            data-bs-toggle="modal"
                            data-bs-target="#add-review"
                            ><i class="feather-plus-circle me-2"></i>Add Review</a
                          >
                        </div>
                      </div>
                      <ul>
                        <li>
                          <div class="order-comment">
                            <div class="rating">
                              <i class="ti ti-star-filled me-1 text-warning"></i>
                              <i class="ti ti-star-filled me-1 text-warning"></i>
                              <i class="ti ti-star-filled me-1 text-warning"></i>
                              <i class="ti ti-star-filled me-1 text-warning"></i>
                              <i class="ti ti-star-filled me-1 text-warning"></i>
                            </div>
                            <h6>A wonderful experience was all the help...</h6>
                            <p>
                              <i class="fa-solid fa-calendar-days me-1"></i> September 5,
                              2023
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- /Reviews -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <pages-footer></pages-footer>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
